import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { rootReducerKey, TIMELINE_REDUCER_TOKEN, timelineReducerProvider } from './timeline.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TimelineEffects } from './timeline.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, TIMELINE_REDUCER_TOKEN),
    EffectsModule.forFeature([TimelineEffects])
  ],
  providers: [
    timelineReducerProvider
  ]
})
export class TimelineStoreModule { }
